<template>
  <div class="login-container"
       :style="'background: url(' + back + ') no-repeat 0% 0% / 100% 100%;'">
    <el-row class="login-main">
      <el-col>
        <p class="sys-name mb-30">{{systemTitle}}</p>
      </el-col>
      <el-col>
        <el-form :model="loginForm"
                 @keyup.enter.native="submitForm('loginForm')"
                 :rules="rules"
                 ref="loginForm"
                 class="demo-loginForm">
          <el-form-item label=""
                        prop="username">
            <el-input v-model.trim="loginForm.username"
                      placeholder="账号"></el-input>
          </el-form-item>
          <el-form-item label=""
                        prop="password">
            <el-input v-model="loginForm.password"
                      show-password
                      placeholder="密码"></el-input>
          </el-form-item>
          <el-form-item class="alignCenter">
            <el-button type="primary"
                       @click="submitForm('loginForm')">登录</el-button>
          </el-form-item>
          <p class="alignRight">
            <el-link type="primary"
                     @click="forget">忘记密码</el-link>
          </p>
        </el-form>
      </el-col>
    </el-row>
    <el-dialog title="密保问题"
               :visible.sync="forgetModal"
               width="375px">
      <el-col :span="24">
        <el-form :model="userInfo"
                 :rules="userRules"
                 ref="userInfo"
                 label-position="top"
                 class="user-form">
          <el-form-item label="账号"
                        prop="username">
            <el-input v-model.trim="userInfo.username"
                      placeholder="请输入账号"></el-input>
          </el-form-item>
          <el-form-item label="您的生日："
                        prop="answer1">
            <el-input type="password"
                      v-model="userInfo.answer1"
                      placeholder="请输入您的生日"></el-input>
          </el-form-item>
          <el-form-item label="您父亲的姓名："
                        prop="answer2">
            <el-input type="password"
                      v-model="userInfo.answer2"
                      placeholder="请输入您父亲的姓名"></el-input>
          </el-form-item>
          <el-form-item label="您母亲的姓名："
                        prop="answer3">
            <el-input type="password"
                      v-model="userInfo.answer3"
                      placeholder="请输入您母亲的姓名"></el-input>
          </el-form-item>
        </el-form>
      </el-col>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="forgetModal = false">取 消</el-button>
        <el-button type="primary"
                   @click="confirmReset('userInfo')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import fetch from '@/common/api'
export default {
  data() {
    return {
      back: '',
      systemTitle: '',
      loginForm: {
        username: '',
        password: ''
      },
      rules: {
        username: [{ required: true, message: '请输入用户名' }],
        password: [{ required: true, message: '请输入密码' }]
      },
      userInfo: {
        username: '',
        answer1: '',
        answer2: '',
        answer3: ''
      },
      userRules: {
        username: [{ required: true, message: '请输入账号' }],
        answer1: [{ required: true, message: '请输入您的生日' }],
        answer2: [{ required: true, message: '请输入您父亲的姓名' }],
        answer3: [{ required: true, message: '请输入您母亲的姓名' }]
      },
      forgetModal: false
    }
  },
  created() {
    this.getSysInfo()
  },
  mounted() {
    this.loginForm.password = ''
    this.loginForm.username = ''
  },
  methods: {
    getSysInfo() {
      fetch.getSysInfo({}).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.back = fetch.downImgUrl + data.back
            this.systemTitle = data.title
            localStorage.setItem('logo', data.logo)
            localStorage.setItem('systemTitle', data.title)
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    forget() {
      this.forgetModal = true
      this.userInfo = {
        username: '',
        answer1: '',
        answer2: '',
        answer3: ''
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          fetch
            .login({ password: this.loginForm.password, username: this.loginForm.username })
            .then((data) => {
              data.procData(
                data.res,
                (data) => {
                  this.$message.success('登录成功')
                  localStorage.setItem('token', data.token)
                  localStorage.setItem('uId', data.userInfo.id)
                  localStorage.setItem('mobile', data.userInfo.mobile)
                  localStorage.setItem('username', data.userInfo.username)
                  localStorage.setItem('avatar', data.userInfo.picture)
                  Promise.all([this.getList(data.userInfo.id), this.getBtnList(data.userInfo.id)])
                    .then((res) => {
                      let data0 = res[0]
                      let data1 = res[1]
                      if (!data0.length) {
                        this.$message.warning('未拥有菜单权限，请联系管理员分配权限后重试')
                        localStorage.clear()
                        return
                      }
                      let toPath = data0[0].children[0].uri
                      localStorage.setItem('buttonList', JSON.stringify(data1))
                      this.$router.push({
                        path: toPath
                      })
                    })
                    .catch((e) => console.log(e))
                  // this.getBtnList()
                  // this.$router.push({
                  //   path: '/'
                  // })
                },
                (err) => {
                  this.$message.error(err)
                }
              )
            })
        }
      })
    },
    confirmReset(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          fetch.forgetPass({ ...this.userInfo }).then((data) => {
            data.procData(
              data.res,
              (data) => {
                this.$refs[formName].resetFields()
                this.$alert('重置密码为：' + data.new_password, '重置密码', {
                  confirmButtonText: '确定',
                  callback: () => {
                    this.forgetModal = false
                  }
                })
              },
              (err) => {
                this.$message.error(err)
              }
            )
          })
        }
      })
    },
    // 获取列表
    getList(id) {
      const promise = new Promise((resolve) => {
        fetch.getMenu({ id: id }).then((data) => {
          data.procData(
            data.res,
            (data) => {
              resolve(data.treeData)
              // this.menuList = data.treeData
            },
            (err) => {
              this.$message.error(err)
            }
          )
        })
      })
      return promise
    },
    getBtnList(id) {
      const promise = new Promise((resolve) => {
        fetch.getBtnList({ id: id }).then((data) => {
          data.procData(
            data.res,
            (data) => {
              resolve(data.list)
              // let btnDatas = JSON.stringify(data.list)
              // localStorage.setItem('buttonList', btnDatas)
            },
            (err) => {
              this.$message.error(err)
            }
          )
        })
      })
      return promise
    }
  }
}
</script>

<style lang="less">
.login-container {
  width: 100%;
  height: 100%;
  // background: url('./../../assets/img/login-bg.png') no-repeat, #1e2e42;
  // background-size: 100% 100%;
  // background: linear-gradient(#fefefe, #2b4858, #001938);
  @media screen and (max-width: 450px) {
    .login-main {
      border: 1px solid #dcdfe6;
      border-radius: 15px;
      background: #fff;
      padding: 80px 30px;
      width: 90%;
      position: relative;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      vertical-align: middle;
    }
  }
  @media screen and (min-width: 1020px) {
    .login-main {
      border: 1px solid #dcdfe6;
      border-radius: 15px;
      background: #fff;
      padding: 80px 30px;
      width: 420px;
      position: relative;
      left: 50%;
      top: 50%;
      transform: translateY(-50%);
      vertical-align: middle;
    }
  }
  .sys-name {
    color: #1e2e42;
    text-align: center;
    font-size: 28px;
  }
}
</style>
